import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

export const DURATION_MAP = {
    'extra-fast': 100,
    fast: 200,
    normal: 300,
    slow: 500,
    'extra-slow': 800,
};

export default function createTransition(displayName, classNames) {
    function Transition({ in: inProp, appear, duration, children, ...innerRest }) {
        const timeout = duration in DURATION_MAP ? DURATION_MAP[duration] : duration;

        const content = React.cloneElement(
            children,
            {
                ...children.props,
                style: {
                    ...children.props.style,
                    transitionDuration: `${timeout}ms`,
                },
            },
            children.props.children
        );

        return (
            <CSSTransition
                unmountOnExit
                in={inProp}
                appear={appear}
                timeout={timeout}
                classNames={classNames}
                {...innerRest}
            >
                {content}
            </CSSTransition>
        );
    }

    Transition.propTypes = {
        in: PropTypes.bool,
        appear: PropTypes.bool,
        duration: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(Object.keys(DURATION_MAP))]),
    };

    Transition.defaultProps = {
        in: false,
        appear: false,
        duration: 'slow',
    };

    Transition.displayName = displayName;

    return Transition;
}
